/* eslint-disable react/destructuring-assignment */
import React, { useContext, useState } from "react";
import { string, shape, arrayOf, bool, func } from "prop-types";
import FormattedAmount from "pages/_components/FormattedAmount";
import { TransactionContext } from "pages/_components/TransactionCard/TransactionContext";
import { echeqPropTypes } from "pages/echeck/echeckPropTypes";
import CustomData from "pages/_components/CustomData/CustomData";
import { TransactionSign } from "pages/_components/TransactionCard";
import Avatar from "pages/_components/Avatar";
import * as i18n from "util/i18n";
import GridTable from "pages/_components/GridTable/GridTable";
import CustomText from "pages/_components/CustomText/CustomText";
import Button from "pages/_components/Button";
import { isIOS } from "react-device-detect";

const EndorseEchekSummaryBody = (props) => {
    const { transaction = {} } = useContext(TransactionContext);
    const { data = {}, idTransaction = "" } = transaction;
    const { showMoreData, setShowMoreData } = props;
    const [buttonLabel, setButtonLabel] = useState("echecks.seeMore.button");
    const {
        beneficiary = props.beneficiary.document,
        beneficiaryName = props.beneficiary.reference,
        type = props.type,
        reference = props.reference,
        referencevalue = props.referencevalue,
        echeqList = props.echeqList,
        isDesktop = props.isDesktop,
    } = data;

    const handleSeeMoreData = () => {
        setShowMoreData(!showMoreData);
        if (!showMoreData) {
            setButtonLabel("echecks.seeLess.button");
        } else {
            setButtonLabel("echecks.seeMore.button");
        }
    };
    const echeq = echeqList[0];

    return (
        <div className="ticket__body echeq-endorse">
            {props.isTicket ? (
                <>
                    <div
                        className="grid-table-data flex"
                        style={{
                            gridArea: "1 / 1 / span 1 / span 8",
                            justifyContent: "center",
                            flexDirection: "row",
                            textAlign: "center",
                        }}>
                        <div className="ticket-section-flex">
                            {isDesktop && (
                                <Avatar
                                    user={{
                                        userFullName: beneficiaryName,
                                        defaultAvatarId: 0,
                                        email: props.beneficiary?.email,
                                    }}
                                />
                            )}

                            <div className="user-info">
                                <CustomText textType="I18N" text="debin.receiver" className="custom-data-title" />
                                <div className="large">{beneficiaryName}</div>
                                <div className="content-center flex">{beneficiary}</div>
                            </div>

                            <CustomData
                                dataClass="amount tag tag-warning"
                                titleText="echecks.amount"
                                titleTextType="I18N"
                                valueText={<FormattedAmount currency={echeq.emisor_moneda} quantity={echeq.monto} />}
                            />
                        </div>
                    </div>

                    <div className="view-more-data-button">
                        <div className="ticket__divider inside-ticket__body">
                            <div className="ticket__notch ticket__notch--left"> </div>
                            <div className="ticket__notch ticket__notch--right"> </div>
                        </div>
                        <Button
                            aria-expanded={showMoreData ? "true" : "false"}
                            className="more-button"
                            label={buttonLabel}
                            bsStyle="link"
                            onClick={handleSeeMoreData}
                            image={showMoreData ? "figma/icon/arrow-up.svg" : "figma/icon/arrow-down.svg"}
                        />
                    </div>
                    <div className={`view-more-data ${showMoreData ? "expand " : "collapse"}`}>
                        <h2 className={isIOS && "mb-8"}>{i18n.get("creditBill.aditionalData.label")}</h2>
                        <div className="ticket-section">
                            <GridTable.Data>
                                <CustomData
                                    titleText="echecks.emit.emision.label"
                                    titleTextType="I18N"
                                    valueText={`····${echeq?.emisor_cbu?.slice(-4)} ${echeq?.cheque_tipo} ${i18n.get(
                                        `currency.label.${echeq?.emisor_moneda}`,
                                    )}`}
                                />
                            </GridTable.Data>

                            <GridTable.Data>
                                <CustomData
                                    titleText="echecks.cession.beneficiary"
                                    titleTextType="I18N"
                                    valueText={beneficiaryName}
                                />
                            </GridTable.Data>
                            <GridTable.Data>
                                <CustomData titleText="echecks.document" titleTextType="I18N" valueText={beneficiary} />
                            </GridTable.Data>
                            <GridTable.Data>
                                <CustomData
                                    titleText="echecks.amount"
                                    titleTextType="I18N"
                                    valueText={echeq.monto}
                                    valueTextType={echeq.emisor_moneda}
                                />
                            </GridTable.Data>
                            <GridTable.Data>
                                <CustomData
                                    titleText="echecks.createdRange.label"
                                    titleTextType="I18N"
                                    valueText={echeq.fecha_emision}
                                    valueTextType="DATE"
                                />
                            </GridTable.Data>
                            <GridTable.Data>
                                <CustomData
                                    titleText="echecks.payedRange.label"
                                    titleTextType="I18N"
                                    valueText={echeq.fecha_pago}
                                    valueTextType="DATE"
                                />
                            </GridTable.Data>
                            <GridTable.Data>
                                <CustomData
                                    titleText="echecks.currency"
                                    titleTextType="I18N"
                                    valueText={echeq?.moneda}
                                />
                            </GridTable.Data>
                            <GridTable.Data>
                                <CustomData
                                    titleText="echeq.request.amount.label"
                                    titleTextType="I18N"
                                    valueText={echeqList?.length}
                                />
                            </GridTable.Data>
                            <GridTable.Data>
                                <CustomData
                                    titleText="echeq.transaction.check.amount.label"
                                    titleTextType="I18N"
                                    valueText={echeq.monto}
                                    valueTextType={echeq.emisor_moneda}
                                />
                            </GridTable.Data>
                            {/* <GridTable.Data>
                        <CustomData
                            titleText="echecks.id.label"
                            titleTextType="I18N"
                            valueText={echeq.cheque_id}
                            valueTextType="TEXT"
                        />
                    </GridTable.Data> */}
                            <GridTable.Data>
                                <CustomData
                                    titleText="echecks.endorse.type.label"
                                    titleTextType="I18N"
                                    valueText={`echecks.endorse.types.${type}`}
                                    valueTextType="I18N"
                                />
                            </GridTable.Data>
                            <GridTable.Data>
                                <CustomData
                                    titleText="echecks.echeckType"
                                    titleTextType="I18N"
                                    valueText={echeq.cheque_tipo}
                                    valueTextType="TEI18NXT"
                                />
                            </GridTable.Data>
                            <GridTable.Data>
                                <CustomData
                                    titleText="echecks.echeckNature"
                                    titleTextType="I18N"
                                    valueText={echeq.cheque_caracter}
                                    valueTextType="TEXT"
                                />
                            </GridTable.Data>
                            <GridTable.Data>
                                <CustomData
                                    titleText="echecks.echeckMode"
                                    titleTextType="I18N"
                                    valueText={echeq.cheque_modo === 1 ? "echecks.emit.cross" : "echecks.emit.uncross"}
                                    valueTextType="I18N"
                                />
                            </GridTable.Data>
                            <GridTable.Data>
                                <CustomData
                                    titleText="echecks.echeckConcept"
                                    titleTextType="I18N"
                                    valueText={echeq.cheque_concepto}
                                    valueTextType="TEXT"
                                />
                            </GridTable.Data>
                            <GridTable.Data>
                                <CustomData
                                    titleText="echecks.echeckReason"
                                    titleTextType="I18N"
                                    valueText={echeq.cheque_motivo_pago}
                                />
                            </GridTable.Data>
                            <GridTable.Data>
                                <CustomData
                                    titleText="echecks.echeckReference"
                                    titleTextType="I18N"
                                    valueText={reference}
                                />
                            </GridTable.Data>
                            <GridTable.Data>
                                <CustomData
                                    titleText="echecks.echeckReferenceValue"
                                    titleTextType="I18N"
                                    valueText={referencevalue}
                                />
                            </GridTable.Data>
                        </div>
                        <TransactionSign
                            idTransaction={idTransaction}
                            isDesktop={isDesktop}
                            showMoreData={showMoreData}
                        />
                    </div>
                </>
            ) : (
                <GridTable className="form-summary">
                    <GridTable.Container columns={props.isTicket ? 4 : 3}>
                        <GridTable.Data>
                            <CustomData
                                titleText="echecks.emit.emision.label"
                                titleTextType="I18N"
                                valueText={`····${echeq?.emisor_cbu?.slice(-4)} ${echeq?.cheque_tipo} ${i18n.get(
                                    `currency.label.${echeq?.emisor_moneda}`,
                                )}`}
                            />
                        </GridTable.Data>
                        {/* <GridTable.Data>
                        <CustomData
                            titleText="echecks.number.label"
                            titleTextType="I18N"
                            valueText={echeq.cheque_numero}
                        />
                    </GridTable.Data> */}
                        <GridTable.Data>
                            <CustomData
                                titleText="echecks.cession.beneficiary"
                                titleTextType="I18N"
                                valueText={beneficiaryName}
                            />
                        </GridTable.Data>
                        <GridTable.Data>
                            <CustomData titleText="echecks.document" titleTextType="I18N" valueText={beneficiary} />
                        </GridTable.Data>
                        <GridTable.Data>
                            <CustomData
                                titleText="echecks.amount"
                                titleTextType="I18N"
                                valueText={echeq.monto}
                                valueTextType={echeq.emisor_moneda}
                            />
                        </GridTable.Data>
                        <GridTable.Data>
                            <CustomData
                                titleText="echecks.createdRange.label"
                                titleTextType="I18N"
                                valueText={echeq.fecha_emision}
                                valueTextType="DATE"
                            />
                        </GridTable.Data>
                        <GridTable.Data>
                            <CustomData
                                titleText="echecks.payedRange.label"
                                titleTextType="I18N"
                                valueText={echeq.fecha_pago}
                                valueTextType="DATE"
                            />
                        </GridTable.Data>
                        <GridTable.Data>
                            <CustomData titleText="echecks.currency" titleTextType="I18N" valueText={echeq?.moneda} />
                        </GridTable.Data>
                        <GridTable.Data>
                            <CustomData
                                titleText="echeq.request.amount.label"
                                titleTextType="I18N"
                                valueText={echeqList?.length}
                            />
                        </GridTable.Data>
                        <GridTable.Data>
                            <CustomData
                                titleText="echeq.transaction.check.amount.label"
                                titleTextType="I18N"
                                valueText={echeq.monto}
                                valueTextType={echeq.emisor_moneda}
                            />
                        </GridTable.Data>
                        {/* <GridTable.Data>
                        <CustomData
                            titleText="echecks.id.label"
                            titleTextType="I18N"
                            valueText={echeq.cheque_id}
                            valueTextType="TEXT"
                        />
                    </GridTable.Data> */}
                        <GridTable.Data>
                            <CustomData
                                titleText="echecks.endorse.type.label"
                                titleTextType="I18N"
                                valueText={`echecks.endorse.types.${type}`}
                                valueTextType="I18N"
                            />
                        </GridTable.Data>
                        <GridTable.Data>
                            <CustomData
                                titleText="echecks.echeckType"
                                titleTextType="I18N"
                                valueText={echeq.cheque_tipo}
                                valueTextType="TEI18NXT"
                            />
                        </GridTable.Data>
                        <GridTable.Data>
                            <CustomData
                                titleText="echecks.echeckNature"
                                titleTextType="I18N"
                                valueText={echeq.cheque_caracter}
                                valueTextType="TEXT"
                            />
                        </GridTable.Data>
                        <GridTable.Data>
                            <CustomData
                                titleText="echecks.echeckMode"
                                titleTextType="I18N"
                                valueText={echeq.cheque_modo === 1 ? "echecks.emit.cross" : "echecks.emit.uncross"}
                                valueTextType="I18N"
                            />
                        </GridTable.Data>
                        <GridTable.Data>
                            <CustomData
                                titleText="echecks.echeckConcept"
                                titleTextType="I18N"
                                valueText={echeq.cheque_concepto}
                                valueTextType="TEXT"
                            />
                        </GridTable.Data>
                        <GridTable.Data>
                            <CustomData
                                titleText="echecks.echeckReason"
                                titleTextType="I18N"
                                valueText={echeq.cheque_motivo_pago}
                            />
                        </GridTable.Data>
                        <GridTable.Data>
                            <CustomData
                                titleText="echecks.echeckReference"
                                titleTextType="I18N"
                                valueText={reference}
                            />
                        </GridTable.Data>
                        <GridTable.Data>
                            <CustomData
                                titleText="echecks.echeckReferenceValue"
                                titleTextType="I18N"
                                valueText={referencevalue}
                            />
                        </GridTable.Data>
                    </GridTable.Container>
                </GridTable>
            )}
        </div>
    );
};

EndorseEchekSummaryBody.propTypes = {
    beneficiary: shape({
        reference: string,
        document: string,
    }),
    echeqList: arrayOf(echeqPropTypes),
    type: string,
    referencevalue: string,
    reference: string,
    isTicket: bool,
    isDesktop: bool,
    showMoreData: bool,
    setShowMoreData: func,
};

EndorseEchekSummaryBody.defaultProps = {
    beneficiary: {
        reference: "",
        document: "",
    },
    echeqList: [],
    type: "",
    referencevalue: "",
    reference: "-",
    isTicket: false,
    isDesktop: false,
    showMoreData: false,
    setShowMoreData: () => {},
};

export default EndorseEchekSummaryBody;
